export const translations = {
  DELIVERY_IMPORT: 'Cargar datos de entrega',
  LOADING_IMPORT: 'Cargar datos de carga',
  FREIGHT_IMPORT: 'Cargar detalles de carga',
  MASTER_IMPORT: 'Cargar datos maestros',
  START_IMPORT: 'Iniciar importación',
  APP_TITLE: 'Cargador de datos | Jules AI',
  LOGISTIC_FORWARDER: 'Seleccionar transitario logístico',
  LOGISTIC_FORWARDER_NAME: 'Transitario logístico',
  SHIPPING_LINE_NAME: 'Línea marítima',
  LOADING_UNIT: 'Unidad de volumen y tipo de carga',
  DELIVERY_UNIT: 'Unidad de volumen y tipo de entrega',
  GO: 'Ir a',
  GO_BACK: 'Volver atrás',
  IMPORT_DELIVERIES: 'Importar entregas',
  IMPORT_LOADINGS: 'Importar cargas',
  CHECKOUT_DELIVERIES_ON_APP: 'Comprobar las entregas en la aplicación web',
  CHECKOUT_LOADINGS_ON_APP: 'Comprobar las cargas en la aplicación web',
  IMPORT_DATA: 'Importar datos',
  POPUP_VALIDATION: 'Campos obligatorios',
  POPUP_LOADING_VALIDATION: 'Todos los campos son obligatorios',
  LOADING_TYPE: 'Seleccione el tipo de carga',
  DELIVERY_TYPE: 'Seleccione el tipo de entrega',
  VALIDITY_MONTH: 'Seleccione el mes de validez',
  LOGISTIC_MATERIAL: 'Seleccionar material logístico',
  QUALITY_GROUP: 'Seleccionar grupo de calidad',
  INCO_TERMS: 'Seleccionar incoterm',
  LOGISTIC_FORWARDER_SHIPPING_LINE: 'Seleccionar valor',
  FREIGHT_POPUP: 'Seleccione los siguientes detalles',
  INVALID_CREDENTIALS: 'Su email y/o contraseña son incorrectos',
  VALID_CREDENTIALS: 'Inicio de sesión correcto',
  SAMPLE_TEMPLATE: 'Descargar plantilla',
  SUPPORT_HELP: 'Soporte',
  CONTRACT_IMPORT: 'Detalles del contrato de renovación',
  CONTRACT: 'Renovar contrato',
  CONFIRMATION_TEXT: '¿Está seguro de que desea renovar los registros?',
  CONFIRMATION_YES: 'Sí',
  CONFIRMATION_NO: 'No',
  RENEW: 'Renovar',
  RENEWING_TEXT: 'Renovar los registros',
  FROM: 'de',
  TO: 'a',
  LOADINGS_HEADER: 'Cargas',
  DELIVERIES_HEADER: 'Entregas',
  FREIGHT_HEADER: 'Carga',
  MASTER_HEADER: 'Maestro',
  CONTRACT_RENEWAL_HEADER: 'Renovación de contrato',
  LOGOUT: 'Cierre de sesión',
  VOLUME_UNIT: 'Seleccione la unidad de volumen',
  MATERIAL: 'Material',
  ITEM: 'Artículo',
  LOADING_TEXT: 'Espere, por favor',
  'The commodity or material name': 'Nombre de la mercancía o del material',
  'The material name cannot be blank':
    'El nombre del material no puede estar en blanco',
  'Net Weight': 'Peso neto',
  'Quantity of material in delivery': 'Cantidad de material en la entrega',
  'Quantity cannot be left blank': 'La cantidad no puede dejarse en blanco',
  'Date of delivery': 'Fecha de entrega',
  'Date of delivery cannot be left blank':
    'La fecha de entrega no puede dejarse en blanco',
  'Reference number': 'Número de referencia',
  'Container reference number': 'Número de referencia del contenedor',
  'ERP Container id': 'ERP ID del contenedor',
  'Gross Weight': 'Peso bruto',
  'Maximum Gross Weight': 'Peso bruto máximo',
  'General comment': 'Comentario general',
  'Loading comment': 'Comentario de carga',
  'Delivery comment': 'Comentario de entrega',
  'Tare Weight': 'Peso de tara',
  'Packages': 'Paquetes',
  'Quantity in tons': 'Cantidad en toneladas',
  'Quantity converted to tons': 'Cantidad convertida a toneladas',
  'Quality id': 'Id de calidad',
  'The id linked to the quality name':
    'El id vinculado al nombre de la calidad',
  'Container id': 'Id de contenedor',
  'The truck plate number or container reference number':
    'El número de matrícula del camión o el número de referencia del contenedor',
  'Jules number': 'Número Jules',
  'CT number for the truck or container': 'Número CT del camión o contenedor',
  'Other delivery number': 'Otro número de entrega',
  'Any other delivery reference number':
    'Cualquier otro número de referencia de entrega',
  'Buy operation id': 'Identificador de operación de compra',
  'Sell operation id': 'Identificador de operación de venta',
  'Container operation quality id': 'Id. de operación de contenedor',
  'Unit (qty)': 'Unidad (cant.)',
  'Seal number': 'Número de precinto',
  'Container seal number': 'Número de precinto del contenedor',
  'Thickness': 'Espesor',
  'Unit (thickness)': 'Unidad (grosor)',
  'Length': 'Longitud',
  'Unit (length)': 'Unidad (longitud)',
  'Width': 'Anchura',
  'Unit (width)': 'Unidad (anchura)',
  'Height': 'Altura',
  'Unit (height)': 'Unidad (altura)',
  'Unit (dimensions)': 'Unidad (dimensiones)',
  'User delivery type': 'Tipo de entrega al usuario',
  'Package Reference': 'Referencia de paquete',
  'Delivery tare weight quantity': 'Cantidad de tara de entrega',
  'Delivery tare weight cannot be left blank':
    'Peso de tara de entrega no puede dejarse en blanco',
  'Delivery tare weight volume': 'Volumen de tara de entrega',
  'Delivery tare volume cannot be left blank':
    'Volumen de tara de entrega no puede dejarse en blanco',
  'Height cannot be left blank': 'La altura no puede dejarse en blanco',
  'Height unit cannot be left blank':
    'La unidad de altura no puede dejarse en blanco',
  'Dimension unit cannot be left blank':
    'La unidad de medida no puede dejarse en blanco',
  'Thickness cannot be left blank': 'El grosor no puede dejarse en blanco',
  'Thickness unit cannot be left blank':
    'La unidad de grosor no puede dejarse en blanco',
  'If you press the \"Go back\" button, you will lose the progress of the current step.':
    // eslint-disable-next-line max-len
    'Si pulsa el botón "Volver atrás", perderá el progreso del paso actual.',
  'If you press the \"Go back\" button, you will lose the entire progress of all steps.':
    'Si pulsa el botón "Volver atrás", perderá el progreso de todos los pasos.',  
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    '¿Está seguro de que desea enviar los datos? Las filas con error no se importarán. En caso afirmativo, utilice el botón "Enviar". En caso contrario, pulse el botón "Atrás".',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    '¿Está seguro de que desea enviar sus datos? En caso afirmativo, utilice el botón "Enviar". En caso contrario, pulse el botón "Atrás".',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    '¿Está seguro de que desea enviar sus datos? Las filas con error también se importarán. En caso afirmativo, utilice el botón "Enviar". En caso contrario, pulse el botón "Atrás".',
  // eslint-disable-next-line max-len
  'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.':
    // eslint-disable-next-line max-len
    'Su importación ha dado lugar a errores {{error}}. Si desea corregir estos errores dentro de la aplicación, pulse el botón "Continuar". Si no, puede descargar la tabla combinada como Excel (.xlsx) pulsando el botón "Exportar como Excel".',
  'Port of loading': 'Puerto de carga',
  'Port of loading should not be blank':
    'El puerto de carga no debe estar en blanco',
  'Port of destination': 'Puerto de destino',
  'Port of destination should not be blank':
    'El puerto de destino no debe estar en blanco',
  'Shipping line': 'Línea de expedición',
  'Shipping line should not be left blank':
    'La línea de expedición no debe dejarse en blanco',
  'Material group': 'Grupo de materias',
  'Material group should not be left blank':
    'El grupo de materiales no debe dejarse en blanco',
  'Cost':'Coste',
  'Cost currency':'Moneda de coste', 
  'Comment':'Comentario', 
  'Other cost':'Otros costes',
  'Other cost currency':'Otra moneda de coste',
  'BL cost':'Coste BL',
  'BL currency':'Moneda BL',
  'Customs currency': 'Moneda aduanera',
  'Freight cost': 'Gastos de transporte',
  'Freight cost should not be left blank':
    'El coste del flete no debe dejarse en blanco',
  'Freight cost currency code': 'Código de moneda del flete',
  'Logistic forwarder': 'Transportista logístico',
  'Logistic material': 'Material logístico',
  'Incoterm': 'Incoterm',
  'Comment': 'Comentario',
  'Other cost': 'Otros costes',
  'Other cost currency': 'Moneda de otros costes',
  'Comment on freight': 'Comentario sobre el flete',
  'Last validity date': 'Última fecha de validez',
  'First validity date': 'Primera fecha de validez',
  'Cost volume': 'Volumen de costes',
  'Cost volume should not be left blank':
    'El volumen de costes no debe dejarse en blanco',
  'BL cost value': 'Valor del coste BL',
  'Currency code of BL cost': 'Código de moneda del coste BL',
  'Miscellaneous cost': 'Costes varios',
  'Currency code of THC admin cost':
    'Código de moneda del coste administrativo THC',
  'Other cost volume': 'Volumen de otros costes',
  'Other cost volume should not be left blank':
    'El volumen de otros costes no debe dejarse en blanco',
  'Customs cost': 'Costes aduaneros',
  'Currency code of custom cost': 'Código de moneda del coste aduanero',
  'Select validity month':'Seleccione el mes de validez',
  'Select logistic material':'Seleccionar material logístico',
  'Select quality group':'Seleccionar grupo de calidad',
  'Select incoterm':'Seleccionar incoterm',
  'Check out freights on web app':'Consultar los fletes en la aplicación web',
  'Import Freight':'Flete de importación',
  'Date of loading': 'Fecha de carga',
  'Date of loading cannot be left blank':'La fecha de carga no puede dejarse en blanco',
  'Container / Truck number':'Número de contenedor / camión',
  'MGW':'MGW',
  'Weight unit':'Unidad de peso',
  'Material ID':'ID material',
  'User loading type':'Tipo de carga del usuario',
  'ERP container ID':'ERP ID contenedor',
  'Transport Rate':'Tarifa de transporte',
  'Upload transport rate details':'Cargar detalles de la tarifa de transporte',
  'Select transport mode':'Seleccione el modo de transporte',
  'Barge': 'Barge',
  'Rail': 'Rail',
  'Road': 'Road',
  'Select transport type':'Seleccione el tipo de transporte',
  'Select material group':'Seleccionar grupo de materiales',
  'Check out transport rates on web app':'Consulte las tarifas de transporte en la aplicación web',
  'Transport cost currency code':'Código de moneda del coste del transporte',
  'Carrier':'Transportista',
  'Loading area':'Zona de carga',
  'Destination area':'Zona de destino',
  'Logistics':'Logística',
  'Import transport rate':'Tarifa de transporte de importación',
  'Transport mode': 'Modo de transporte',
  'cost': 'coste',
  'Volumic customs cost':'Coste aduanero volumétrico',
  'Volumic customs currency':'Divisa aduanera volumétrica',
  'Currency code of volumic customs':'Código de divisa de las aduanas volumétricas',
  'Volumic customs volume':'Volumen de la aduana volumétrica',
  "Volumic customs volume shouldn't be left blank":"El volumen aduanero volumétrico no debe dejarse en blanco",
  'Demurrage in days':'Demora en días',
  'Detention in days':'Retención en días',
  'Lane':'Carril',
  'First validity date cannot be left blank' :'La primera fecha de validez no puede dejarse en blanco',
  'Last validity date cannot be left blank' :'La última fecha de validez no puede dejarse en blanco',
  "Transport All In Rate": "Transporte Tarifas todo incluido",
  "Pre-carriage area": "Zona previa al carruaje",
  "Pre carriage volume": "Volumen previo al transporte",
  "Pre carriage cost": "Coste de transporte previo",
  "Pre carriage currency": "Moneda anterior al transporte",
  "Packing type": "Tipo de embalaje",
  "Single container": "Contenedor individual",
  "Multiple container": "Contenedor múltiple",
  "UPLOAD_TYPE": "Seleccione el tipo de carga",
  CONFIRMATION_TEXT_SAMPLE_DOC: "Si ha encontrado problemas al abrir el archivo en Excel, haga clic en sí",
  CONFIRMATION_CONTINUE: 'Continuar',
  CONFIRMATION_CANCEL: 'Cancelar',
  "Select deviation type": "Seleccione el tipo de desviación",
  "Sterile Weight": "Peso estéril",
  "Sterile Gross Weight": "Peso bruto estéril",
  "Pieces": "Piezas",
  "Upload container info": "Cargar información del contenedor",
  "Delivery info": "Información de entrega",
  "Loading info": "Información de carga",
  "Logistic rates": "Tarifas logísticas",
  "Export": "Exportar",
  "Local": "Local",
};
